module.exports = __webpack_public_path__ + "static/media/github.8a423376.png";